import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { getById } from "../../../../services/RHService/ContratDePartegeService";
import { useParams } from "react-router-dom";
import PDFGenerator from "./PDFGenerator";
import { useLocation } from "react-router-dom";

const DetailsContratDePartage = () => {
  const location = useLocation();
  const idContratP = new URLSearchParams(location.search).get("idContratP");

  const [contratDePartage, setContratDePartage] = useState({});
  const fetchData = async () => {
    const resp = await getById(idContratP);
    setContratDePartage(resp.data.success);
  };
  console.log(contratDePartage);
  useEffect(() => {
    fetchData();
  }, []);
  const dateDeb = new Date(contratDePartage.dateDeb); // ensure date objects are used
  const dateFin = new Date(contratDePartage.dateFin);
  const timeDiff = dateFin.getTime() - dateDeb.getTime();
  const dayDiff = timeDiff / (1000 * 3600 * 24);
  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-4 col-md-4">
              <h1 className="m-0">Détail de Contrat de partage d'action</h1>
            </div>
            <div className="col-sm-8 col-md-8">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/mission_interne">
                    Liste des Contrats de partage
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  Détail de Contrat de partage
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div class="card">
              <div className="card-header">
                <h5>Contrat de partage</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div className="col-md-3">
                    <strong className="center">Intitulé</strong>
                    <br></br>
                    {contratDePartage ? contratDePartage.intitule : ""}
                  </div>
                  <div className="col-md-3">
                    <strong className="center">Nom de bénificitaire</strong>
                    <br></br>
                    {contratDePartage ? contratDePartage.nomBenif : ""}{" "}
                  </div>

                  <div className="col-md-3">
                    <strong className="center">Contact</strong>
                    <br></br>
                    {contratDePartage ? contratDePartage.contact : ""}{" "}
                  </div>

                  <div className="col-md-3">
                    <strong className="center">Mode de paiement</strong>
                    <br />
                    {contratDePartage
                      ? contratDePartage.modePaiment === "espéce"
                        ? "Espèce"
                        : contratDePartage.modePaiment === "VIREMENT"
                        ? `Virement Bancaire : ${contratDePartage.rib}`
                        : contratDePartage.modePaiment === "chéque"
                        ? `Chèque : ${contratDePartage.rib}`
                        : null
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div class="card">
              <div className="card-header">
                <h5>Dates</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div className="col-md-3">
                    <strong className="center">Date début</strong>
                    <br></br>
                    {contratDePartage ? contratDePartage.dateDeb : ""}{" "}
                  </div>

                  <div className="col-md-3">
                    <strong className="center">Date fin</strong>
                    <br></br>
                    {contratDePartage ? contratDePartage.dateFin : ""}
                  </div>
                  <div className="col-md-3">
                    <strong className="center">Nombre de jours</strong>
                    <br></br>
                    {dayDiff ? dayDiff : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div class="card">
              <div className="card-header">
                <h5>Liste des charges</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  {contratDePartage && contratDePartage.charges ? (
                    contratDePartage.charges.map((charge, index) => (
                      <div className="col-md-3" key={index}>
                        <strong className="center">{charge.nomCharge}</strong>
                        <br></br>
                        {charge.frais}dt
                      </div>
                    ))
                  ) : (
                    <p>Loading charges...</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h5>Description</h5>
              </div>
              <div className="card-body">
                <p> {contratDePartage ? contratDePartage.desc : ""} </p>
              </div>
            </div>
            <div className="card-footer">
              <button
                type="submit"
                className="btn btn-danger col-md-3 float-right"
                style={{ width: "auto", color: "white" }}
              >
                <PDFDownloadLink
                  document={
                    <PDFGenerator
                      id={idContratP}
                      contratDePartage={contratDePartage}
                    />
                  }
                  fileName="Contrat de partage.pdf"
                  style={{ color: "white" }}
                >
                  {({ blob, url, loading, error }) =>
                    loading ? "Loading document..." : "Télecharger"
                  }
                </PDFDownloadLink>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DetailsContratDePartage;
